import * as fromDatatype from "../datatype-library/index";

export interface bl_inv_stock_conversion_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  foreign_ccy: boolean;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.CurrencyCodeDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  point_start_date: fromDatatype.TimestampTzDatatypeInterface;
  point_end_date: fromDatatype.TimestampTzDatatypeInterface;
  multi_level_disc_json: fromDatatype.JsonDatatypeInterface;
  posting_bundle: fromDatatype.VarcharDatatypeInterface;
  finance_charge_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  posting_mto: fromDatatype.VarcharDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
}

export class bl_inv_stock_conversion_line_RowClass
  implements bl_inv_stock_conversion_line_RowInterface
{
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  foreign_ccy: boolean;
  doc_ccy: fromDatatype.CurrencyCodeDataFieldInterface;
  amount_cogs: fromDatatype.MoneyDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.NumericDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  amount_json: fromDatatype.JsonDatatypeInterface;
  amount_open_balance: fromDatatype.MoneyDatatypeInterface;
  amount_signum: fromDatatype.NumericDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.TextDatatypeInterface;
  item_desc: fromDatatype.TextDatatypeInterface;
  item_remarks: fromDatatype.TextDatatypeInterface;
  item_reference_no: fromDatatype.TextDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  quantity_signum: fromDatatype.NumericDatatypeInterface;
  quantity_base: fromDatatype.NumericDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  line_property_json: fromDatatype.JsonDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  qty_open: fromDatatype.NumericDatatypeInterface;
  serial_no: fromDatatype.JsonDatatypeInterface;
  batch_no: fromDatatype.JsonDatatypeInterface;
  point_amount: fromDatatype.NumericDatatypeInterface;
  point_currency: fromDatatype.CurrencyCodeDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  unit_price_by_uom: fromDatatype.NumericDatatypeInterface;
  qty_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_disc_by_uom: fromDatatype.NumericDatatypeInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  tracking_id: fromDatatype.VarcharDatatypeInterface;
  far_hdr_guid: fromDatatype.GuidDataFieldInterface;
  uom: fromDatatype.VarcharDatatypeInterface;
  unit_price_std: fromDatatype.NumericDatatypeInterface;
  unit_price_txn: fromDatatype.NumericDatatypeInterface;
  unit_price_std_by_uom: fromDatatype.NumericDatatypeInterface;
  unit_price_txn_by_uom: fromDatatype.NumericDatatypeInterface;
  uom_to_base_ratio: fromDatatype.NumericDatatypeInterface;
  bin_no: fromDatatype.JsonDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  qty_reserve_adj: fromDatatype.NumericDatatypeInterface;
  unit_price_net: fromDatatype.NumericDatatypeInterface;
  point_start_date: fromDatatype.TimestampTzDatatypeInterface;
  point_end_date: fromDatatype.TimestampTzDatatypeInterface;
  multi_level_disc_json: fromDatatype.JsonDatatypeInterface;
  posting_bundle: fromDatatype.VarcharDatatypeInterface;
  finance_charge_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  cost_ma_price: fromDatatype.NumericDatatypeInterface;
  cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  cost_wa_price: fromDatatype.NumericDatatypeInterface;
  cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  cost_lifo_price: fromDatatype.NumericDatatypeInterface;
  cost_manual_amount: fromDatatype.NumericDatatypeInterface;
  cost_manual_price: fromDatatype.NumericDatatypeInterface;
  cost_replacement_amount: fromDatatype.NumericDatatypeInterface;
  cost_replacement_price: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_location: fromDatatype.NumericDatatypeInterface;
  cost_last_purchase_company: fromDatatype.NumericDatatypeInterface;
  posting_mto: fromDatatype.VarcharDatatypeInterface;
  landed_txn_amount: fromDatatype.NumericDatatypeInterface;
  landed_txn_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_ma_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_wa_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_fifo_price: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_amount: fromDatatype.NumericDatatypeInterface;
  landed_cost_lifo_price: fromDatatype.NumericDatatypeInterface;
}
